export default class insertBg {
  init () {
    this.bgByDataAttr();
  }
  bgByDataAttr () {
    const $elm = $('.js-insert_bg');
    $elm.each(function() {
      const data = $(this).data('bg');
      if(data.url){
        $(this).css('background-image', 'url(' + data.url + ')');
      }
      if(data.color){
        $(this).css('background-color', data.color);
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/insert_bg.js